module.exports = ".kan-header {\n  border-bottom: 1px solid #d3d3d3;\n  -webkit-box-shadow: 2px 2px #eeeeee;\n          box-shadow: 2px 2px #eeeeee;\n  z-index: 100;\n  padding: 2px 8px; }\n  .kan-header .kan-logo {\n    height: 50px;\n    width: auto;\n    cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/header/component.scss
// module id = ./src/modules/main/components/header/component.scss
// module chunks = main